module.exports = __webpack_public_path__ + "static/img/jbsq.40d6da75.png";